const VUE_APP_NAME = 'ASCENDEX';//网站名称
// 正式
const VUE_APP_WS_URL = 'wss://www.ascendexus.com/websocket';//正式
const VUE_APP_BASEURL = 'https://www.ascendexus.com'
    // 'www.plotio.top';//正式
const VUE_API1_BASEURL = 'https://yq.ascendexus.com';//返佣接口域名
const VUE_API2_BASEURL = 'https://vm.lenteiga.com/0nw8idvazemyo0r6u0prrvvzb2';//在线客服域名


// 测试
// const VUE_APP_WS_URL = 'ws://127.0.0.1:8080/websocket';//测试
// const VUE_APP_BASEURL = 'http://127.0.0.1:8080';//测试
// const VUE_API1_BASEURL = 'http://127.0.0.1:8080';//返佣接口域名
// const VUE_API2_BASEURL = 'http://127.0.0.1:8080';//在线客服域名



export { VUE_APP_WS_URL, VUE_APP_BASEURL,VUE_API1_BASEURL,VUE_API2_BASEURL,VUE_APP_NAME };